@if (inspectionPdfs()) {
  <nb-alert>
    <div class="info-alert">
      <nb-icon icon="info-outline" pack="eva"></nb-icon>
      <span>Dokumente werden ca. 30 Tage nach der letzten Generierung gelöscht!</span>
    </div>
  </nb-alert>

  <div class="pdf-options">
    @for (option of context.visiblePdfOptions(); track option.type) {
      <wr-inspection-pdf-entry
        [label]="option.label"
        [inspectionPdfType]="option.type"
        [inspection]="inspection()"
        [inspectionPdf]="pdfsByType()[option.type]">
      </wr-inspection-pdf-entry>
    }

    <div class="download-item" [nbSpinner]="downloadingImages()" nbSpinnerStatus="primary">
      <nb-icon icon="image-outline" pack="eva"></nb-icon>
      <div class="download-text">
        <b>Prüfpunktzeilen-Bilder</b>
        <span>{{ downloadingImages() ? 'Wird vorbereitet…' : 'Alle Bilder der Prüfpunktzeilen als ZIP' }}</span>
      </div>
      <nb-button-group class="download-buttons">
        <button (click)="downloadImages()"
                nbButton
                status="basic"
                [disabled]="downloadingImages()"
                nbTooltip="Bilder herunterladen">
          <nb-icon pack="eva" icon="download-outline"></nb-icon>
        </button>
      </nb-button-group>
    </div>
  </div>
}
